import { CommonLaboratoryResponse } from '@/api/services/common.dto'
import { CommonPriorityResponse } from '@/api/services/common/priority/common-priority.dto'
import { ConfigurationCommonDepartmentResponse } from '@/modules/configurationModule/detail/local-samples/target-response-times/services/target-response-types.dto'
import { StatisticalAnalysisHandlerChartActivityDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-activity-dossier/statistical-analysis-handler-chart-activity-dossier'
import { StatisticalAnalysisHandlerExportTableActivityDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-activity-dossier/statistical-analysis-handler-export-activity-dossier'
import { StatisticalAnalysisHandlerChartDelayAndTimeResponsesDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-delays-and-response-times-dossier/statistical-analysis-handler-chart-delays-and-response-times-dossier'
import { StatisticalAnalysisHandlerExportTableDelaysAndResponseTimesDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-delays-and-response-times-dossier/statistical-analysis-handler-export-delays-and-response-times-dossier'
import { StatisticalAnalysisHandlerChartGeneralDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-general-dossier/statistical-analysis-handler-chart-general-dossier'
import { StatisticalAnalysisHandlerExportTableGeneralDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-general-dossier/statistical-analysis-handler-export-table-general-dossier'
import { StatisticalAnalysisHandlerChartIncidentsDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-incidents-dossier/statistical-analysis-handler-chart-incidents-dossier'
import { StatisticalAnalysisHandlerExportTableIncidentsDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-incidents-dossier/statistical-analysis-handler-export-incidents-dossier'
import { StatisticalAnalysisHandlerExternalChartIncidentsDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-incidents-dossier/statistical-analysis-handler-external-chart-dossier'
import { StatisticalAnalysisHandlerChartSampleTagsDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-sample-tags-dossier/statistical-analysis-handler-chart-sample-tags-dossier'
import { StatisticalAnalysisHandlerExportTableSampleTagDossier } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handlers-sample-tags-dossier/statistical-analysis-handler-export-sample-tags-dossier'
import { StatisticalAnalysisActivityStatisticsDossierDetailViewTableContentCase } from '@/modules/statistical-analysis-module/services/activity-dossier/activity-dossier.dto'
import { StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableParsed } from '@/modules/statistical-analysis-module/services/delay-and-response-times-dossier/delay-and-response-times-dossier.dto'
import { StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContent } from '@/modules/statistical-analysis-module/services/general-statistics-dossier/general-statistics-dossier.dto'
import { StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent, StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.dto'
import { StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTableContentCase } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.dto'
import { StatisticalAnalysisHeaderNavigationItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { StatisticalAnalysisTemporalFilterEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-temporal-filter/statistical-analysis-temporal-filter.model'
import { StatisticalAnalysisViewDetailChartFilterAxisCombo, StatisticalAnalysisViewDetailChartFilterAxisXY } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-axis/statistical-analysis-view-detail-chart-filters-axis.model'
import { StatisticalAnalysisViewDetailChartFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.model'
import { StatisticalAnalysisViewDetailTableFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'
import { StatisticalAnalysisExternalListCase } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-cases'
import { StatisticalAnalysisExternalListPortion } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-portions'
import { StatisticalAnalysisExternalListSample } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-samples'
import { StatisticalAnalysisExternalListSubportion } from '@/modules/statistical-analysis-module/shared/external-list-columns/external-list-columns-subportions'
import { StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo } from '@/modules/statistical-analysis-module/views/delays-and-response-time-dossier/delays-and-response-time-dossier.model'
import { StatisticalAnalysisGeneralDossierExternalInfo } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { StatisticalAnalysisIncidentsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/incidents-dossier/incidents-dossier.model'
import { StatisticalAnalysisSampleTagsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/labeled-samples-dossier/labeled-samples-dossier.model'
import { StatisticalAnalysisActivityDossierExternalInfo } from '@/modules/statistical-analysis-module/views/service-activity-dossier/service-activity-dossier.model'
import { Nullable } from '@/shared/types/app.types'
import moment from 'moment'
import { DateUtils } from '@/shared/util/date-utils'

export enum StatiscalAnalysisTypeCases {
    CASE = 'CASE',
    SAMPLE = 'SAMPLE',
    PATIENT = 'PATIENT',
    GENERAL = 'GENERAL',
    REQUEST = 'REQUEST',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION'
}

export enum StatisticalAnalysisCaseTypes {
    REQUESTED = 'REQUESTED',
    REGISTERED = 'REGISTERED',
    REPORTED = 'REPORTED',
    TRANSCRIBED = 'TRANSCRIBED',
    VALIDATED = 'VALIDATED',
    VALIDATED_ADDITIONAL_REPORT = 'VALIDATED_ADDITIONAL_REPORT',
    VALIDATED_AMENDMENT = 'VALIDATED_AMENDMENT'
}

export enum StatisticalAnalysisIncidentTypes {
    OCCURRED = 'OCCURRED',
    OPENED = 'OPENED',
    CLOSED = 'CLOSED'
}

export enum StatisticalAnalysisActivityTypes {
    TOTAL = 'TOTAL',
    UCL = 'UCL',
    URV = 'URV'
}

export enum StatisticalAnalysisDossiers {
    GENERAL = 'general',
    ACTIVITY = 'activity',
    DELAYS_AND_RESPONSE_TIMES = 'delayAndResponseTimes',
    INCIDENTS = 'incidents',
    SAMPLE_TAGS = 'sampleTag'
}

export enum StatisticalAnalysisDelayAndResponseEnum {
    REGISTER = 'REGISTER',
    SECRETARIAT = 'SECRETARIAT',
    DIAGNOSIS = 'DIAGNOSIS',
    GLOBAL = 'GLOBAL'
}

export enum StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum {
    TRO = 'RESPONSE_TIME',
    DELAY = 'DELAY'
}

export enum StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum {
    COMPLETED = 'COMPLETED',
    DELAYED = 'DELAYED'
}

export enum StatisticalAnalysisIncidentsTimesTypeSelectorEnum {
    OPENING = 'OPEN_TIME',
    CLOSING = 'CLOSE_TIME'
}

export enum StatisticalAnalysisTimesheetEnum {
    MINUTES = 'MINUTES',
    HOURS = 'HOURS',
    DAYS = 'DAYS',
    WEEKS = 'WEEKS',
    MONTHS = 'MONTHS',
    YEARS = 'YEARS'
}

export enum StatisticalAnalysisComboTypes {
    MAIN = 'MAIN',
    ASSOCIATED = 'ASSOCIATED'
}

export enum StatisticalAnalysisComboPreselections {
    // To case entity
    PATHOLOGIST = 'PATHOLOGIST',
    CASE_TYPE = 'CASE_TYPE',
    // To sample entity
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    TOPOGRAPHIC_CODE = 'TOPOGRAPHIC_CODE',
    // To portion entity
    PORTION_TYPE = 'PORTION_TYPE',
    GENERATION_PERSONNEL = 'GENERATION_PERSONNEL',
    // To subportion entity
    SUBPORTION_TYPE = 'SUBPORTION_TYPE',
    ASSAYS_GROUP = 'ASSAYS_GROUP',
}

export interface StatisticalAnalysisViewDetailTableParamsTemporalFilter {
    isShow: boolean
    preselection?: StatisticalAnalysisTemporalFilterEnum
}

export interface StatisticalAnalysisViewDetailTableParamsContextMenuItems {
    detailList: boolean
    detailChart: boolean
}
export interface StatisticalAnalysisViewDetailTableParams {
    contextMenuItems: StatisticalAnalysisViewDetailTableParamsContextMenuItems
    temporalFilter?: StatisticalAnalysisViewDetailTableParamsTemporalFilter
}

export interface StatisticalAnalysisViewDetailChartParams {
    axis: StatisticalAnalysisViewDetailChartFilterAxisXY
    showExtendedFilters: boolean
}

export interface StatisticalAnalysisViewDetailParams {
    dossier: StatisticalAnalysisDossiers
    table: StatisticalAnalysisViewDetailTableParams
    chart: StatisticalAnalysisViewDetailChartParams
}

export interface StatisticalAnalysisViewDetailTableGroupingColumns {
    value: string
    literal: string
    groupedBy: string
}

export interface StatisticalAnalysisDynamicObject {
    [key: string]: string[]
}

export class StatisticalAnalysisEnumsAndKeys {
    // Axis
    public static readonly PATHOLOGIST = new StatisticalAnalysisEnumsAndKeys('PATHOLOGIST', 'statisticalAnalysis.grids.pathologist')
    public static readonly CASE_TYPE = new StatisticalAnalysisEnumsAndKeys('CASE_TYPE', 'statisticalAnalysis.grids.caseType')
    public static readonly PHYSICIAN_HEALTH_MANAGEMENT_AREA = new StatisticalAnalysisEnumsAndKeys('PHYSICIAN_HEALTH_MANAGEMENT_AREA', 'statisticalAnalysis.grids.requestingHealthManagementArea')
    public static readonly PHYSICIAN_DEPARTMENT = new StatisticalAnalysisEnumsAndKeys('PHYSICIAN_DEPARTMENT', 'statisticalAnalysis.grids.requestingDepartment')
    public static readonly PHYSICIAN_CENTER = new StatisticalAnalysisEnumsAndKeys('PHYSICIAN_CENTER', 'statisticalAnalysis.grids.requestingCenter')
    public static readonly PHYSICIAN_UNIT = new StatisticalAnalysisEnumsAndKeys('PHYSICIAN_UNIT', 'statisticalAnalysis.grids.requestingDepartment')
    public static readonly PHYSICIAN_PETITIONER = new StatisticalAnalysisEnumsAndKeys('PHYSICIAN_PETITIONER', 'statisticalAnalysis.grids.requestingProfessional')
    public static readonly DESTINATION_HEALTH_MANAGEMENT_AREA = new StatisticalAnalysisEnumsAndKeys('DESTINATION_HEALTH_MANAGEMENT_AREA', 'statisticalAnalysis.grids.destinationHealthManagementArea')
    public static readonly DESTINATION_CENTER = new StatisticalAnalysisEnumsAndKeys('DESTINATION_CENTER', 'statisticalAnalysis.grids.destinationCenter')
    public static readonly DESTINATION_UNIT = new StatisticalAnalysisEnumsAndKeys('DESTINATION_UNIT', 'statisticalAnalysis.grids.destinationDepartment')
    public static readonly DESTINATION = new StatisticalAnalysisEnumsAndKeys('DESTINATION', 'statisticalAnalysis.grids.receiver')
    public static readonly RESIDENT = new StatisticalAnalysisEnumsAndKeys('RESIDENT', 'statisticalAnalysis.grids.resident')
    public static readonly CASE_OF_REFERENCE = new StatisticalAnalysisEnumsAndKeys('CASE_OF_REFERENCE', 'statisticalAnalysis.grids.consultationCase')
    public static readonly PRIORITY = new StatisticalAnalysisEnumsAndKeys('PRIORITY', 'statisticalAnalysis.grids.priority')
    public static readonly REGIME = new StatisticalAnalysisEnumsAndKeys('REGIME', 'statisticalAnalysis.grids.regime')
    public static readonly LABORATORY = new StatisticalAnalysisEnumsAndKeys('LABORATORY', 'statisticalAnalysis.grids.laboratory')
    public static readonly COMPETENCE = new StatisticalAnalysisEnumsAndKeys('COMPETENCE', 'statisticalAnalysis.grids.serviceCompetence')
    public static readonly COMPETENCES = new StatisticalAnalysisEnumsAndKeys('COMPETENCES', 'statisticalAnalysis.grids.serviceCompetencies')
    public static readonly INCIDENT_ORIGIN = new StatisticalAnalysisEnumsAndKeys('INCIDENT_ORIGIN', 'statisticalAnalysis.grids.incidentOrigin')
    public static readonly INCIDENT_TYPE = new StatisticalAnalysisEnumsAndKeys('INCIDENT_TYPE', 'statisticalAnalysis.grids.incidentType')
    public static readonly INCIDENT_SEVERITY = new StatisticalAnalysisEnumsAndKeys('INCIDENT_SEVERITY', 'statisticalAnalysis.grids.severity')
    public static readonly CORE_ENTITY = new StatisticalAnalysisEnumsAndKeys('CORE_ENTITY', 'statisticalAnalysis.grids.affectedEntity')
    public static readonly OPENED_BY = new StatisticalAnalysisEnumsAndKeys('OPENED_BY', 'statisticalAnalysis.grids.openingResponsible')
    public static readonly CLOSED_BY = new StatisticalAnalysisEnumsAndKeys('CLOSED_BY', 'statisticalAnalysis.grids.closingResponsible')
    public static readonly IS_OPEN = new StatisticalAnalysisEnumsAndKeys('IS_OPEN', 'statisticalAnalysis.grids.isOpen')
    public static readonly PHASE = new StatisticalAnalysisEnumsAndKeys('PHASE', 'statisticalAnalysis.grids.casePhase')
    public static readonly SAMPLE_TYPE = new StatisticalAnalysisEnumsAndKeys('SAMPLE_TYPE', 'statisticalAnalysis.grids.sampleType')
    public static readonly RESPONSIBLE_REGROSSING = new StatisticalAnalysisEnumsAndKeys('RESPONSIBLE_REGROSSING', 'statisticalAnalysis.grids.grossingProcessingResponsible')
    public static readonly SAMPLE_PROCESS = new StatisticalAnalysisEnumsAndKeys('SAMPLE_PROCESS', 'statisticalAnalysis.grids.samples')
    public static readonly MOST_LIKELY_MORPHOLOGIC_CODE = new StatisticalAnalysisEnumsAndKeys('MOST_LIKELY_MORPHOLOGIC_CODE', 'statisticalAnalysis.grids.mostLikelyDiagnose')
    public static readonly PROCEDURE = new StatisticalAnalysisEnumsAndKeys('PROCEDURE', 'statisticalAnalysis.grids.procedure')

    // Case types
    public static readonly REQUESTED = new StatisticalAnalysisEnumsAndKeys('REQUESTED', 'statisticalAnalysis.dossiers.generalStatistics.status.requested')
    public static readonly REGISTERED = new StatisticalAnalysisEnumsAndKeys('REGISTERED', 'statisticalAnalysis.dossiers.generalStatistics.status.registered')
    public static readonly REPORTED = new StatisticalAnalysisEnumsAndKeys('REPORTED', 'statisticalAnalysis.dossiers.generalStatistics.status.informed')
    public static readonly TRANSCRIBED = new StatisticalAnalysisEnumsAndKeys('TRANSCRIBED', 'statisticalAnalysis.dossiers.generalStatistics.status.transcribed')
    public static readonly VALIDATED_ADDITIONAL_REPORT = new StatisticalAnalysisEnumsAndKeys('VALIDATED_ADDITIONAL_REPORT', 'statisticalAnalysis.dossiers.generalStatistics.status.additionalReport')
    public static readonly VALIDATED_AMENDMENT = new StatisticalAnalysisEnumsAndKeys('VALIDATED_AMENDMENT', 'statisticalAnalysis.dossiers.generalStatistics.status.amendment')

    // Case entities
    public static readonly CASE = new StatisticalAnalysisEnumsAndKeys(StatiscalAnalysisTypeCases.CASE, 'statisticalAnalysis.entities.case')
    public static readonly SAMPLE = new StatisticalAnalysisEnumsAndKeys(StatiscalAnalysisTypeCases.SAMPLE, 'statisticalAnalysis.entities.sample')
    public static readonly GENERAL = new StatisticalAnalysisEnumsAndKeys(StatiscalAnalysisTypeCases.GENERAL, 'statisticalAnalysis.entities.general')
    public static readonly PATIENT = new StatisticalAnalysisEnumsAndKeys(StatiscalAnalysisTypeCases.PATIENT, 'statisticalAnalysis.entities.patient')
    public static readonly REQUEST = new StatisticalAnalysisEnumsAndKeys(StatiscalAnalysisTypeCases.REQUEST, 'statisticalAnalysis.entities.request')
    public static readonly PORTION = new StatisticalAnalysisEnumsAndKeys(StatiscalAnalysisTypeCases.PORTION, 'statisticalAnalysis.entities.portion')
    public static readonly SUBPORTION = new StatisticalAnalysisEnumsAndKeys(StatiscalAnalysisTypeCases.SUBPORTION, 'statisticalAnalysis.entities.subportion')

    // Delays and Response Times
    public static readonly REGISTER = new StatisticalAnalysisEnumsAndKeys('REGISTER', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.table.registry')
    public static readonly SECRETARIAT = new StatisticalAnalysisEnumsAndKeys('SECRETARIAT', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.table.secretary')
    public static readonly DIAGNOSIS = new StatisticalAnalysisEnumsAndKeys('DIAGNOSIS', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.table.diagnose')
    public static readonly GLOBAL = new StatisticalAnalysisEnumsAndKeys('GLOBAL', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.table.global')

    public static readonly TRO = new StatisticalAnalysisEnumsAndKeys('RESPONSE_TIME', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.responseTime')
    public static readonly DELAY = new StatisticalAnalysisEnumsAndKeys('DELAY', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.delays')

    public static readonly COMPLETED = new StatisticalAnalysisEnumsAndKeys('COMPLETED', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.table.responseTimeCompleted')
    public static readonly DELAYED = new StatisticalAnalysisEnumsAndKeys('DELAYED', 'statisticalAnalysis.dossiers.delaysAndResponseTimes.table.responseTimeDelayed')

    public static readonly OPENING = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisIncidentsTimesTypeSelectorEnum.OPENING, 'statisticalAnalysis.dossiers.incidents.openingTimes')
    public static readonly CLOSING = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisIncidentsTimesTypeSelectorEnum.CLOSING, 'statisticalAnalysis.dossiers.incidents.closingTimes')

    public static readonly ACTIVITY_TOTAL = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisActivityTypes.TOTAL, 'statisticalAnalysis.charts.generalSerie')
    public static readonly UCL = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisActivityTypes.UCL, 'statisticalAnalysis.grids.workUnitTotal')
    public static readonly URV = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisActivityTypes.URV, 'statisticalAnalysis.grids.valueUnitTotal')

    // Sections
    public static readonly GENERAL_STATISTICS = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisDossiers.GENERAL, 'statisticalAnalysis.sections.generalStatistics')
    public static readonly ACTIVITY_STATISTICS = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisDossiers.ACTIVITY, 'statisticalAnalysis.sections.serviceActivity')
    public static readonly INCIDENTS_STATISTICS = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisDossiers.INCIDENTS, 'statisticalAnalysis.sections.incidents')
    public static readonly DELAYS_AND_RESPONSE_STATISTICS = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisDossiers.DELAYS_AND_RESPONSE_TIMES, 'statisticalAnalysis.sections.delaysAndResponseTimes')
    public static readonly SAMPLE_TAGS_STATISTICS = new StatisticalAnalysisEnumsAndKeys(StatisticalAnalysisDossiers.SAMPLE_TAGS, 'statisticalAnalysis.sections.labeledSamples')

    id!:string
    text!: string

    constructor(id: string, text: string) {
        this.id = id
        this.text = text
    }

    getModel(): StatisticalAnalysisViewDetailChartFilterAxisCombo {
        return { id: this.id, text: this.text }
    }

    getId(): string {
        return this.id
    }

    getText(): string {
        return this.text
    }
}

export interface StatisticalAnalysisCommonStats {
    total: number
    percent: number
    maxTime: number
    minTime: number
    mean: number
    median: number
    deviation: number
    totalCases?: number
    totalSamples?: number
    totalPortions?: number
    totalSubportions?: number
}

export interface StatisticalAnalysisCommonPathologist {
    id: number
    name: string
    middleName: string
    surname1: string
    surname2: string
    active: boolean
    fullName: string
    code: string
}

export interface StatisticalAnalysisCommonCaseType {
    id: number
    description: string
    active: boolean
}

export interface StatisticalAnalysisPhysicianDepartment extends ConfigurationCommonDepartmentResponse {}

export interface StatisticalAnalysisDestinationDepartment extends ConfigurationCommonDepartmentResponse {}

export interface StatisticalAnalysisCommonPriority extends CommonPriorityResponse {}

export interface StatisticalAnalysisPhysicianHealthManagementArea {
    id: number
    name: string
    code: string
    active: boolean
}
export interface StatisticalAnalysisDestinationHealthManagementArea {
    id: number
    name: string
    code: string
    active: boolean
}
export interface StatisticalAnalysisRegime {
    id: number
    name: string
    code: string
    active: boolean
}

export interface StatisticalAnalysisResident {
    id: number
    name: string
    middleName: string
    surname1: string
    surname2: string
    active: boolean
    fullName: string
    code: string
}

export interface StatisticalAnalysisLaboratory extends CommonLaboratoryResponse {}

export type StateTypes = StatisticalAnalysisCaseTypes | StatisticalAnalysisDelayAndResponseEnum
// Pending to add sample types, portion types...
export type StatisticalAnalysisExternalListTypes = StatisticalAnalysisExternalListCase | StatisticalAnalysisExternalListSample | StatisticalAnalysisExternalListPortion | StatisticalAnalysisExternalListSubportion
export type StatisticalAnalysisDossiersDatasourceResponsesTypes = StatisticalAnalysisGeneralStatisticsDossierDetailViewTableContent | StatisticalAnalysisDelayAndResponseTimesDossierDetailViewTableParsed | StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent | StatisticalAnalysisActivityStatisticsDossierDetailViewTableContentCase | StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTableContentCase
export type StatisticalAnalysisDossiersDatasourceResponsesDetailTypes = StatisticalAnalysisExternalListTypes | StatisticalAnalysisIncidentsStatisticsDossierDetailExternalViewTableContent
export type StatisticalAnalysisDossiersChartResponsesTypes = StatisticalAnalysisHandlerChartGeneralDossier | StatisticalAnalysisHandlerChartDelayAndTimeResponsesDossier | StatisticalAnalysisHandlerChartIncidentsDossier | StatisticalAnalysisHandlerExternalChartIncidentsDossier | StatisticalAnalysisHandlerChartActivityDossier | StatisticalAnalysisHandlerChartSampleTagsDossier
export type StatisticalAnalysisDossiersDetailExportingTypes = StatisticalAnalysisHandlerExportTableGeneralDossier | StatisticalAnalysisHandlerExportTableIncidentsDossier | StatisticalAnalysisHandlerExportTableDelaysAndResponseTimesDossier | StatisticalAnalysisHandlerExportTableActivityDossier | StatisticalAnalysisHandlerExportTableSampleTagDossier

export type StatisticalAnalysisDossiersFilters = StatisticalAnalysisViewDetailTableFilters | StatisticalAnalysisViewDetailChartFilters
export type StatisticalAnalysisDossiersGeneralHeaderType = StatisticalAnalysisHeaderNavigationItems<StatisticalAnalysisCaseTypes> | StatisticalAnalysisHeaderNavigationItems<number>

export type StatisticalAnalysisDossiersExternalInfo = StatisticalAnalysisGeneralDossierExternalInfo | StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo | StatisticalAnalysisIncidentsDossierExternalInfo | StatisticalAnalysisActivityDossierExternalInfo | StatisticalAnalysisSampleTagsDossierExternalInfo

export const formatDatetimes = (date: Date): string => {
    return moment(date).format(DateUtils.zonedDateTimePattern)
}

export interface StatisticalAnalysisContentScrollTable{
    scrollId: Nullable<Object>
    size: number
    totalElements: Nullable<number>
}
